/**
 * @description 数据页面类型
 */
export enum ReportPermissionEnum {
  REPORT_AUTH = 'RIGHT_TO_REPORT_DATA' // 填报数据权
}
